import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserAutoLoginDTO } from 'src/app/domain/login/component/set-new-password/set-new-password.component';

@Injectable({
  providedIn: 'root',
})

export class UserFirstLoginService {
  // Use this service to transfer users login and password to login.
  // And then calls method log in automatically
  private dataSource = new BehaviorSubject<UserAutoLoginDTO>(undefined);
  currentData = this.dataSource.asObservable();

  changeData(data: UserAutoLoginDTO): void {
    this.dataSource.next(data);
  }
}

